import { useMutation } from '@tanstack/react-query'
import {
  postUnifiedPayoutsV2PostAuth,
  postUnifiedPayoutsV2PreAuth,
} from 'services/UnifiedPayoutsService'

export const useUnifiedPayoutsPreAuthMutation = () => {
  return useMutation({
    mutationFn: postUnifiedPayoutsV2PreAuth,
  })
}

export const useUnifiedPayoutsPostAuthMutation = () => {
  return useMutation({
    mutationFn: postUnifiedPayoutsV2PostAuth,
  })
}
